import { useState, useEffect } from 'react'

export const useAccordion = (moduleName, searchTerm, defaultAccordionId) => {
  const [selectedRow, setSelectedRow] = useState(defaultAccordionId)
  const [highlightedText, setHighlightedText] = useState('')

  useEffect(() => {
    const handleOpenAccordion = (event) => {
      const { accordionId } = event.detail
      setSelectedRow(accordionId)
      setHighlightedText(searchTerm)

      setTimeout(() => {
        setHighlightedText('')
      }, 2000)
    }

    const element = document.getElementById(moduleName)
    element.addEventListener('openAccordion', handleOpenAccordion)

    return () => {
      element.removeEventListener('openAccordion', handleOpenAccordion)
    }
  }, [searchTerm, moduleName])

  const changeSelectedRow = (clickedRowNumber) => {
    setSelectedRow((prevSelectedRow) =>
      prevSelectedRow === clickedRowNumber ? 0 : clickedRowNumber
    )
  }

  return { selectedRow, highlightedText, changeSelectedRow }
}
